import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import usePagination, { PaginationProps } from '@lib/hooks/usePagination';
import { IconName } from '@lib/components/Modal/enums';

function PageOutOfRangeEmptyState(props: PaginationProps) {
  const { t } = useTranslation();
  const { onPageChange } = usePagination(props);

  return (
    <EmptyState
      title={t('page-out-of-range-title')}
      text={t('page-out-of-range-text')}
      icon={IconName.Cancel}
      actions={[
        <Button
          key="first-page"
          buttonText={t('go-to-first-page')}
          buttonType={ButtonTypes.primaryFilled}
          leftIcon="arrow_back"
          onClick={() => onPageChange(1)}
        />,
      ]}
    />
  );
}

export default PageOutOfRangeEmptyState;
